import Service from "./Service"

class ProductService extends Service {

    findById = (id) => this.get(`/products/${id}`)

    findItemById = (id) => this.get(`/products/items/${id}`)

    findAllProductsToOrder = (queryParams) => this.getWithParams(`/products/to-order`, queryParams)

    searchProducts = (queryParams) => this.getWithParams("/products", queryParams)

    searchProductsSimple = (queryParams) => this.getWithParams("/products/simple", queryParams)

    searchProductItemsByName = (queryParams) => this.getWithParams("/products/items", queryParams)

    searchProductItemsBySubStorage = (queryParams) => this.getWithParams("/products/items", queryParams)

    createProduct = (requestBody) => this.post("/products", requestBody)

    updateProductItem = (id, requestBody) => this.patch(`/products/items/${id}`, requestBody)

    discardProductItems = (id, amount) => this.post(`/products/items/${id}/discard`, {amount})

    convertExcelToProductList = (requestBody) => this.postFile("/products/converter", requestBody)

    correctProductItemAmount = (id, amount) => this.post(`/products/items/${id}/corrections`, {amount})

    moveProduct = (requestBody) => this.patch("/products", requestBody)

    deleteFile = (id, fileId) => this.del(`/products/${id}/files/${fileId}`)

    changeProductImage = (id, fileId) => this.patch(`/products/${id}/files/${fileId}`)
}

const productService = new ProductService()
export default productService